import { Pencil } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { RegisteredAgent } from '../dialogs/RegisteredAgentAddressDialog'

type Props = {
  registeredAgents: RegisteredAgent[]
  onEdit: (registeredAgent: RegisteredAgent) => void
}

export function RegisteredAgentSection({ registeredAgents, onEdit }: Props) {
  if (registeredAgents.length === 0) return null

  return (
    <section className="border rounded-lg">
      <div className="px-4 py-3 border-b">
        <h2 className="text-sm font-medium text-foreground">Registered Agent</h2>
      </div>
      <div className="divide-y">
        {registeredAgents.map((agent) => (
          <div key={agent.id} className="flex items-center justify-between gap-3 px-4 py-3">
            <div className="min-w-0">
              <div className="text-sm font-medium text-foreground">{agent.service_provider_name || 'Unnamed agent'}</div>
              <div className="text-xs text-muted-foreground">
                {agent.street_address
                  ? `${agent.street_address}, ${agent.city}${agent.state_province ? `, ${agent.state_province}` : ''} ${agent.postal_code || ''}`.trim()
                  : 'No address on file yet'}
              </div>
            </div>
            <Button variant="ghost" size="sm" className="h-7 text-xs shrink-0" onClick={() => onEdit(agent)}>
              <Pencil className="w-3.5 h-3.5 mr-1" aria-hidden="true" />
              {agent.street_address ? 'Edit address' : 'Add address'}
            </Button>
          </div>
        ))}
      </div>
    </section>
  )
}
